










































































































































































































































































































































import {
  AuthenticationApi,
  FormsApi,
  PatientApi,
  RefreshAccessTokenRequest,
  ImperfectionInceptionDto,
  FeedbackMessage,
  OriginFaultDiscovered,
  ComplaintCategory,
  ComplaintKind
} from "@/api";
import stateMixin from "@/mixins/state";
import moment from "moment";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  data() {
    return {
      environment: process.env.VUE_APP_ENV,
      location: process.env.VUE_APP_LOCATION,
      dropdownData: null,
      startDateMenu: null,
      startTimeMenu: null,
      complaintKinds: null,
      valid: true,
      myFiles: null,
      dateTime: {
        date: null,
        time: null
      },
      requiredFields: ["birthDate", "contactPerson", "feedbackMessage"],
      errors: {},
      filePond: {
        files: null,
        server: {
          url: process.env.VUE_APP_API,
          process: {
            url: "/api/portal/File/UploadFile",
            method: "POST",
            headers: {
              Authorization: ""
            }
          }
        }
      },

      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: {
        pharmacyName: null,
        departmentName: null,
        contactPerson: "",
        emailAddress: null,
        phoneNumber: null,
        isComplaint: undefined,
        feedbackMessage: FeedbackMessage.NoFeedbackNecessary,
        remarks: null,
        additionalInformation: null,
        bagDateTime: null,
        originFaultDiscovered: null,
        complaintCategory: null,
        complaintKind: null,
        crateAmount: 0,
        fromPharmacy: null,
        fromDepartment: null,
        descriptionOther: null,
        takenActions: null,
        explanationQuestion: null,
        imageGuid: null,
        imageExtension: null,
        imageFileType: null
      },

      // Static rules, these fields are always required
      rules: {
        feedbackMessage: [v => !!v || "Terugkoppeling is verplicht"],
        isComplaint: [v => v !== null || "Klacht/Foto opvraag is verplicht"],
        contactPerson: [v => v !== null || "Contactpersoon is verplicht"]
      }
    };
  },
  name: "ReportImperfectionInceptionApeldoorn",
  mixins: [stateMixin],
  components: {
    FilePond
  },
  methods: {
    getDropdownData: async function() {
      this.setState(this.states.LOADING);
      try {
        const api = new FormsApi();
        const { data } = await api.formsGetDropdownDataApeldoorn();

        this.dropdownData = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    submit: async function() {
      this.$refs.form.validate();

      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsReportImperfectionInceptionApeldoorn({
            departmentName: this.fields.departmentName,
            patientId: this.autocomplete.model?.patientId,
            dateTimeBag: this.bagDateTime,
            feedbackMessage: this.fields.feedbackMessage,
            contactPerson: this.fields.contactPerson,
            emailAddress: this.fields.emailAddress,
            phoneNumber: this.fields.phoneNumber,
            isComplaint: this.fields.isComplaint,
            remarks: this.fields.remarks,
            complaintCategory: this.fields.complaintCategory,
            complaintKind: this.fields.complaintKind,
            additionalInformation: this.fields.additionalInformation,
            crateAmount: this.fields.crateAmount,
            department: this.autocomplete.model?.facility,
            descriptionOther: this.fields.descriptionOther,
            takenActions: this.fields.takenActions,
            explanationQuestion: this.fields.explanationQuestion,
            originFaultDiscovered: this.fields.originFaultDiscovered,
            imageGuid: this.fields.imageGuid,
            imageExtension: this.fields.imageExtension,
            imageFileType: this.fields.imageFileType,
            fromPharmacy: this.fields.fromPharmacy,
            fromDepartment: this.fields.fromDepartment
            // bagDate: this.bagDateTime,
          } as ImperfectionInceptionDto);

          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch (e) {
          // @todo, fix this part
          // this.errors = {};
          // Object.keys(e.response.data.errors).forEach((item) => {
          //   this.errors[item.toLowerCase()] = e.response.data.errors[item];
          // });
          this.setState(this.states.ERROR);
        }
      } else {
        setTimeout(() => {
          const errorFields = document.querySelectorAll(
            "div.v-input.error--text"
          );
          if (errorFields) {
            this.$vuetify.goTo(errorFields[0]);
          }
        }, 500);
      }
    },
    async beforeAddFile() {
      const state = this.$store.getters["auth/getAuth"];
      const api = new AuthenticationApi();
      const request: RefreshAccessTokenRequest = {
        accessToken: state.accessToken,
        refreshToken: state.refreshToken
      };
      const { data } = await api.authenticationRefreshAccessToken(request, {
        transformRequest: (data: any, headers: any) => {
          delete headers.common["Authorization"];
          return data;
        }
      });
      this.$store.dispatch("auth/setAuth", data);
      this.filePond.server.process.headers[
        "Authorization"
      ] = `Bearer ${data.accessToken}`;
      return true;
    },
    processUploadedFile(err, file: FilePondFile) {
      this.fields.imageGuid = file.serverId;
    },
    getErrors(property: string) {
      const key = property.toLowerCase();
      return this.errors[key] || this.errors[`$.${key}`] || [];
    },
    resetErrors(property: string) {
      const key = property.toLowerCase();
      this.$delete(this.errors, key);
    },
    formatDate(date: string): string | null {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },
  computed: {
    computedDateFormatted(): string | null {
      return this.formatDate(this.dateTime.date);
    },
    bagDateTime() {
      let date = "";
      if (this.dateTime.date && this.dateTime.time) {
        date = new Date(`${this.dateTime.date} ${this.dateTime.time}`);
      }
      return date ? moment(date).format() : "";
    },
    bagDateRules() {
      if (this.requiredFields && this.requiredFields.indexOf("dateTime") > -1) {
        return [v => !!v || "Datum op zakje is verplicht"];
      }
      return [];
    },
    bagTimeRules() {
      if (this.requiredFields && this.requiredFields.indexOf("dateTime") > -1) {
        return [v => !!v || "Tijdstip op zakje is verplicht"];
      }
      return [];
    },
    contactPersonRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("contactPerson") > -1
      ) {
        return [v => !!v || "Contactpersoon is verplicht"];
      }
      return [];
    },
    complaintRules() {
      if (this.fields.isComplaint === true) {
        return [v => !!v || "Dit veld is verplicht"];
      }
      return [];
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }

      let self = this;
      this.autocomplete.isLoading = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000),
    "fields.complaintCategory": _.debounce(function(val) {
      if (!val) {
        return;
      }

      if (this.fields.complaintCategory === ComplaintCategory.Assortment) {
        this.complaintKinds = this.dropdownData.complaintKinds.Assortment;
      } else if (this.fields.complaintCategory === ComplaintCategory.Delivery) {
        this.complaintKinds = this.dropdownData.complaintKinds.Delivery;
      } else if (
        this.fields.complaintCategory === ComplaintCategory.Medication
      ) {
        this.complaintKinds = this.dropdownData.complaintKinds.Medication;
      } else if (
        this.fields.complaintCategory === ComplaintCategory.MedicationRoll
      ) {
        this.complaintKinds = this.dropdownData.complaintKinds.MedicationRoll;
      } else if (
        this.fields.complaintCategory === ComplaintCategory.ServiceProducts
      ) {
        this.complaintKinds = this.dropdownData.complaintKinds.ServiceProducts;
      }
    }, 100),

    "fields.isComplaint": _.debounce(function(val) {
      if (val === null) {
        return;
      }
      if (val === true) {
        this.fields.explanationQuestion = null;
      } else if (val === false) {
        this.fields.complaintCategory = null;
        this.complaintKinds = null;
        this.fields.originFaultDiscovered = null;
        this.fields.takenActions = null;
      }
    }, 100)
  },
  mounted() {
    this.getDropdownData();
  }
};
